import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmExitModalComponent } from '../dialogs/confirm-exit-dialog/confirm-exit-dialog.component';

export interface CanExit {
  canExit: () => boolean | Observable<boolean> | Promise<boolean>;
}

@Injectable({
  providedIn: 'root',
})
export class ConfirmExitGuard implements CanDeactivate<CanExit> {

  array = [
    'PlanProtectionCompletarComponent'
  ]

  constructor(private dialog: MatDialog) {}

  canDeactivate(component: CanExit): Observable<boolean> | Promise<boolean> | boolean {
    // if(this.array.includes(component.constructor.name) ){
      if(component.canExit()){
        return true
      }else{
        return new Promise((resolve) => {
          const dialogRef = this.dialog.open(ConfirmExitModalComponent, {
            width: '350px',
          });
    
          dialogRef.afterClosed().subscribe((result) => {
            resolve(result); // Solo permite salir si el usuario confirma
          });
        });
      }
    // }else{
    //   return new Promise((resolve) => {
    //     const dialogRef = this.dialog.open(ConfirmExitModalComponent, {
    //       width: '350px',
    //     });
  
    //     dialogRef.afterClosed().subscribe((result) => {
    //       resolve(result); // Solo permite salir si el usuario confirma
    //     });
    //   });
    // }
    
  }
}